
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBuildingColumns, faCreditCard, faMoon } from '@fortawesome/free-solid-svg-icons'

import MenuIcon from '@mui/icons-material/Menu'
import _AppBar from '@mui/material/AppBar'

import { MatomoProvider, createInstance as createMatomoInstance } from '@jonkoops/matomo-tracker-react'

import React, { Fragment as F,
  useContext, useEffect, useLayoutEffect, useRef, useState,
} from 'react'
import Joyride, { ACTIONS, EVENTS, STATUS } from 'react-joyride'
import { useKeycloak } from '@react-keycloak/web'
import Modal from 'react-modal'
import {
  Link,
  BrowserRouter as Router,
  Route,
  Routes,
  useNavigate, useParams,
} from "react-router-dom"
import Select from 'react-select'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import config from 'config'

import { AppCtx } from './App'

import {
  Breadcrumbs,
  MainMenu,
} from '$src/components'
import {
  useApiRouter,
  appRouter,
  C,
  logg,
} from './shared'

import {
  DeleteModal,
  RenameModal,
  ShareModal,
} from '$src/components'
import {
  /* singular */
  BankSchedules,
  // BankShow,
  /* plural */
  BanksCtx,
  BanksSearchModal,
  ResultsTable,
} from './components/banks'
import { FintechsIndex } from './components/fintechs'
import {
  FintegrationResultsModal,
  FintegrationSearchModal,
} from './components/fintegration'
import {
  PeriodsCtx,
  PeriodsModal,
} from './components/periods'
import {
  ListsModal,
  QueryModal,
  QueriesCtx,
  QueriesModal,
} from './components/queries'
import {
  /* singular */
  AdvancedReportEditModal,
  AdvancedReportShowModal,
  PdfModal,
  ReportModal,
  /* plural */
  AdvancedReportsModal,
  ReportsModal,
  UnauthorizedContactsModal,
} from './components/reports'
import {
  DocsSearch,
  SchedulesCtx,
  SchedulesShowModal,
} from './components/schedules'

library.add( faBuildingColumns, faCreditCard, faMoon )


/*
 * LayoutTop
**/
const LayoutTop = (props) => {
  // logg(props, 'LayoutTop')

  const apiRouter = useApiRouter()
  const navigate = useNavigate()
  // const params = useParams()
  // const [ activeRoute, setActiveRoute ] = useState(null)


  const {
    actionName, setActionName,
    cuEmail,
    drawerOpen,   setDrawerOpen,
    joyrideOpen, setJoyrideOpen,
    joyrideRun, setJoyrideRun,
    joyrideStepIdx, setJoyrideStepIdx,
    loading,      setLoading,
    loading2, setLoading2,
  } = useContext(AppCtx)
  // logg(useContext(AppCtx), 'useContext(AppCtx)')

  const {
  } = useContext(BanksCtx)
  // logg(useContext(BanksCtx), 'useContext(BanksCtx)')

  const {
    queryName,
  } = useContext(QueriesCtx)


  // From: https://matomo.org/faq/new-to-piwik/how-do-i-start-tracking-data-with-matomo-on-websites-that-use-react/
  const matomo = createMatomoInstance({
    urlBase: 'https://analytics.fedfis.com/',
    siteId: 2,
    userId: cuEmail,
    // trackerUrl: 'https://analytics.fedfis.com/tracking.php', // optional, default value: `${urlBase}matomo.php`
    // srcUrl: 'https://LINK.TO.DOMAIN/tracking.js', // optional, default value: `${urlBase}matomo.js`
    disabled: false, // optional, false by default. Makes all tracking calls no-ops if set to true.
    heartBeat: {
      active: true,
      seconds: 15,
    },
    linkTracking: true,
    configurations: {
      // disableCookies: true,
      // setSecureCookie: true,
      // setRequestMethod: 'POST'
    },
  })

  const joyrideSteps = [
    { disableBeacon: true,
      target: '.MainMenu .left',
      content: 'Use the Main Menu for navigating around',

    },
    { target: 'li.banks-quick-search',
      content: 'You can search for a bank',
    },
    // { target: 'li.data-dictionary',
    //   content: 'View all descriptions of line items here',
    // },
    { target: '.ScheduleShow .tableW:nth-child(1)',
      content: 'You can right-click on these line items to see a description',
    },
    { target: 'body', content: 'All done, enjoy!', placement: 'center' }
  ];

  const joyrideCb = (props) => {
    // logg(props, 'joyrideCb')
    if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(props.type)) {
      // Update state to advance the tour
      setJoyrideStepIdx(props.index + (props.action === ACTIONS.PREV ? -1 : 1));
    } else if ([STATUS.FINISHED, STATUS.SKIPPED].includes(props.status)) {
      setJoyrideRun(false)
    }
    if ('complete' === props.lifecycle && 'li.banks-quick-search' === props.step.target) {
      setJoyrideRun(false)
      navigate('/banks/37/schedules/ORGPROF')
    }
  }


  if (!cuEmail && !config.skip_keycloak) {
    return <div>.^.</div>
  }

  return <MatomoProvider value={matomo} >
    { joyrideOpen && <Joyride run={joyrideRun} callback={joyrideCb} continuous={true}
        styles={{ options: { overlayColor: 'var(--fff-overlay-bg)', primaryColor: 'var(--fff-primary-bg-color)' } }}
        steps={joyrideSteps}
        stepIndex={joyrideStepIdx} /> }

    <div className={`MainLayoutW ${(actionName||'').replace('#', '-')}`}>
      {/* { loading && <div className='a202408-Loading'>Loading...</div> } */}
      {/* { loading && <div className='a20240914-Loading'><img src="/assets/images/200x200-loading-4.gif" alt='Loading...' /></div> } */}
      { ( loading || loading2 ) && <div className='a20240914-Loading'><img src="/assets/images/spinner_sm.gif" alt='Loading...' /></div> || null }

      <AdvancedReportEditModal />
      <AdvancedReportShowModal />
      <AdvancedReportsModal />
      <BanksSearchModal />
      <DeleteModal />
      <FintegrationResultsModal />
      <FintegrationSearchModal />
      <ListsModal />
      <PeriodsModal />
      <QueryModal />
      <QueriesModal />
      <ReportModal />
      <ReportsModal />
      <RenameModal />
      <SchedulesShowModal />
      <ShareModal />
      <ToastContainer hideProgressBar={true} />
      <UnauthorizedContactsModal />

      <MainMenu />
      <Breadcrumbs />

      <div className="MainLayout">
        <div className="MainLayoutC">
          <Routes>
            <Route path="/"                                        exact element={<ResultsTable />} />
            <Route path="/advanced-reports/:report_id/edit"        exact element={<AdvancedReportEditModal />} />
            <Route path="/fintechs"                                      element={<FintechsIndex />} />
            <Route path={appRouter.banksResultsRoute}                    element={<ResultsTable  />} />
            <Route path={appRouter.bankSchedulesRoute}                   element={<BankSchedules />} />
            <Route path="/banks/:rssd/contacts"                    exact element={<BankSchedules action="banks#contacts" />} />
            <Route path="/banks/:rssd/schedules/:schedule_id"      exact element={<BankSchedules action="banks#schedule" />} />
            <Route path="/data-dictionary/:schedule_id"            exact element={<BankSchedules action="docs#show" />} />

            <Route path="/lists/:list_id"                 exact element={<ResultsTable />} />
            <Route path="/queries/view/:query_ids"        exact element={<ResultsTable />} />
            <Route path={appRouter.queryEditRoute}        exact element={<div></div>} />

            <Route path="/reports/:report_id/edit" exact element={<ReportModal />} />
          </Routes>
        </div>

      </div>{/* end wC */}
    </div>{/* end MainW */}

  </MatomoProvider>
}
export default LayoutTop
export {
  Breadcrumbs,
  LayoutTop,
}

